import {
  APP_PRIVATE_PATHS,
  APP_TOP_LEVEL_PATH,
} from '@epicuro-next/navigation/constants';

export const isPBasket = (url: string): boolean => {
  return (
    url.includes(
      `${APP_PRIVATE_PATHS.browse.path}/${APP_PRIVATE_PATHS.search.path}`,
    ) &&
    !url.includes(
      `${APP_TOP_LEVEL_PATH.cs.outlet}:${APP_TOP_LEVEL_PATH.cs.path}/`,
    )
  );
};
